import { SVGProps } from 'react';

const ReportsBackIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_7_1374" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_7_1374)">
                <path d="M4 6L4 18L2 18L2 6L4 6ZM12 6L13.425 7.4L9.825 11L22 11L22 13L9.825 13L13.4 16.6L12 18L6 12L12 6Z" fill="#637381"/>
            </g>
        </svg>
    );
};

export default ReportsBackIcon;
